module.exports = __webpack_public_path__ + "img/suites-1.c5f11615.jpg";